module.exports = __webpack_public_path__ + "static/media/partner-btm-5.514a7231.png";